/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CustomOutputDataParser = /* #__PURE__ */ parsers.object([
    ['program', codecString],
    ['regex', codecString],
]);
export class CustomOutputData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CustomOutputDataParser.decode(input).map(res => new CustomOutputData(res));
    }
    static unsafeDecode(input) {
        return CustomOutputData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CustomOutputDataParser.encode(data);
    }
    static schema() {
        return CustomOutputDataParser.schema();
    }
}
